module.exports = __webpack_public_path__ + "static/images/tt_authorized.2764dcaedcfa3191d9914844901eb321.png";